<template>
  <div class="pa-pod-room-selector">
    <div class="room-selector">
      <ul class="tag-list">
        <li v-for="room in joinedPodRoomList" :index="room.id" :key="room.id">
          <button
           :class="classList[room.slug]"
           @click.prevent="handleClickButton(room)"
          >{{room.name}}</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {GetPodRoomList} from '@/graphql/queries/ConnectionPod.graphql'

export default {
  data(){
    return {
      classList       : {},
      selectPodRoomId : null,
    };
  },

  computed : {
    podRoomType(){
      return this.$store.state.connection.podRoomType;
    },

    podRoomId(){
      return this.$store.state.connection.podRoomId[this.podRoomType];
    },

    urlQuery(){
      return this.$route.query;
    }
  },

  apollo : {
    joinedPodRoomList : {
      query : GetPodRoomList,
      variables(){
        return {
          roomType  : this.podRoomType
        };
      },
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },
  
  watch : {
    joinedPodRoomList : {
      handler(data){
        if(typeof data === 'undefined') return;
        if(this.podRoomId === null){
          if(typeof this.joinedPodRoomList[0] !== 'undefined'){
            this.setPodRoomId(this.joinedPodRoomList[0].id);
          }
        }

        this.setRoomListClass();
      },
      
      immediate: true
    },

    podRoomId : {
      handler(){
        this.setRoomListClass();
      },

      immediate: true
    },

    urlQuery : {
      handler(data){
        if(typeof data.pod_room_id === 'undefined') return;
        
        this.selectPodRoomId = data.pod_room_id;
      },
      immediate: true,
      deep: true
    },

    selectPodRoomId : {
      handler(value){
        if(value === null) return;

        // 数字で入るので、文字列に変換します。
        this.setPodRoomId(value+'');
      },
      immediate: true
    }
  },

  methods : {
    setPodRoomId(podRoomId){
      this.$store.dispatch({
        type        : 'connection/updatePodRoomId',
        podRoomType : this.podRoomType,
        podRoomId   : podRoomId,
      });
    },

    setRoomListClass(){
      if(typeof this.joinedPodRoomList === 'undefined') return;
      if(this.podRoomId === null) return;

      this.classList = {};
      
      for(let item of this.joinedPodRoomList){
        if(this.podRoomId === item.id){
          this.classList[item.slug] = ['is-selected'];
        }else{
          this.classList[item.slug] = [];
        }
      }
    },

    handleClickButton(roomData){
      if(this.podRoomId === roomData.id) return;
      
      // this.setPodRoomId(roomData.id);
      this.$router.replace({
        name    : 'connections.room',
        params  : {
          roomType : this.podRoomType
        },
        query   : {
          pod_room_id : roomData.id,
        }
      });
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-pod-room-selector{
  position: relative;
  background-color:#C6AC8C;
  width:100%;
  overflow-x: auto;
  margin-bottom:.7rem;

  .room-selector{
    background-color:#C6AC8C;
    padding:.5rem 0;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;

    ul.tag-list{
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
      width: auto;
      padding:0 .5rem;

      &::-webkit-scrollbar {
        display: none;
      }

      li{
        button{
          border:0;
          box-sizing: border-box;
          background-color: #AC8C76;
          color: #7C5E49;
          margin-right: .5rem;
          padding:.2rem .5rem;
          border-radius: 40px;
          font-size:.9rem;

          &:focus {
            outline: none;
          }

          &.is-selected{
            background-color: #A6795B;
            color: #604430;
          }
        }
      }
    }
  }
}
</style>